import { SymbolTopTraderOpenPosition } from '@flipster/apis/v1/community/types';
import { Carousel } from '@flipster/react/design-system-legacy/carousel';
import { Styles } from '@flipster/styled-system/css';

import { SymbolOpenPositionCard } from './card';

interface SymbolOpenPositionCarouselProps {
  openPositions: SymbolTopTraderOpenPosition[];
  css?: Styles;
}
export const SymbolOpenPositionCarousel = ({ openPositions, css: cssProps }: SymbolOpenPositionCarouselProps) => {
  return (
    <Carousel
      css={cssProps}
      slidesPerView={1}
      spaceBetween={8}
      navigator={
        <Carousel.Navigator css={{ mt: 4, ml: 'auto', gridArea: 'arrow-bottom', '& svg': { w: 16, h: 16 } }} />
      }
    >
      {openPositions.map((position) => (
        <Carousel.Slide key={position.id}>
          <SymbolOpenPositionCard position={position} />
        </Carousel.Slide>
      ))}
    </Carousel>
  );
};
